import React from 'react';
import { InternalAuditorTemplate } from '../components/training/templates/InternalAuditorTemplate';
import { getStandardBySlug } from '../data/standards/standardsData';
import { getInternalAuditorContent } from '../data/standards/trainingContent';

export const ISO50001InternalAuditor = () => {
  const standard = getStandardBySlug('iso-50001');
  const content = getInternalAuditorContent('iso-50001');

  return <InternalAuditorTemplate standard={standard} content={content} />;
};
